import { Check, ListChecks, Wallet } from '@phosphor-icons/react';

import { WizardStepHeader } from '../../wizard';
import { cn } from '../../../utils/cn';
import pt from '../../../locales/pt';
import { GoalTermHint } from '../GoalTermHint';

export function SmartGoalTypeStep({ measurementType, onSelect }) {
  const copy = pt.goals.wizard.type;
  const types = pt.goals.measurementType;

  const cards = [
    {
      id: 'monetary',
      icon: Wallet,
      label: types.chooseMonetary,
      help: types.chooseMonetaryHelp,
      term: 'monetary',
    },
    {
      id: 'checklist',
      icon: ListChecks,
      label: types.chooseChecklist,
      help: types.chooseChecklistHelp,
      term: 'checklist',
    },
  ];

  return (
    <div className="flex flex-col gap-3.5 pt-2">
      <WizardStepHeader eyebrow={copy.eyebrow} title={copy.title} subtitle={copy.subtitle} />

      <div className="flex flex-col gap-3">
        {cards.map((card) => {
          const selected = measurementType === card.id;
          const Icon = card.icon;
          return (
            <button
              key={card.id}
              type="button"
              onClick={() => onSelect(card.id)}
              className={cn(
                'flex w-full items-start gap-3.5 rounded-2xl border-[1.5px] px-[15px] py-[15px] text-left transition',
                selected
                  ? 'border-sage-600 bg-card shadow-[0_0_0_3px_rgba(244,247,240,1)] dark:border-sage-500 dark:shadow-[0_0_0_3px_rgba(74,98,67,0.25)]'
                  : 'border-border bg-card',
              )}
            >
              <span
                className={cn(
                  'flex h-11 w-11 shrink-0 items-center justify-center rounded-[13px]',
                  selected
                    ? 'bg-sage-100 text-sage-700 dark:bg-sage-900 dark:text-sage-300'
                    : 'bg-muted text-muted-foreground',
                )}
              >
                <Icon className="h-6 w-6" aria-hidden />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 font-display text-[15.5px] font-semibold text-foreground">
                    {card.label}
                    <span
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => e.stopPropagation()}
                      role="presentation"
                    >
                      <GoalTermHint term={card.term} variant="icon" />
                    </span>
                  </span>
                  <span
                    className={cn(
                      'ml-auto flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2',
                      selected
                        ? 'border-sage-600 bg-sage-600 text-white dark:border-sage-500 dark:bg-sage-500'
                        : 'border-border',
                    )}
                    aria-hidden
                  >
                    {selected ? <Check className="h-3 w-3" weight="bold" /> : null}
                  </span>
                </span>
                <span className="mt-1.5 block text-[12.5px] leading-snug text-muted-foreground">
                  {card.help}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SmartGoalTypeStep;
